import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import Highcharts from 'highcharts/highstock.src';
import SeriesLabel from 'highcharts/modules/series-label';
SeriesLabel(Highcharts);


    ko.bindingHandlers.flexiChart = {
        update: function (element, valueAccessor, allBindings) {
            var $chartEl;

            var chartOptions = ko.unwrap(allBindings.get('dataAndOptions'));
            var chartData = chartOptions.data,
                selected = chartOptions.selectedIndexes,
                defaultHeight = 320;

            var totalSubTitle = {
                text: 'Total: ',
                align: 'left',
                floating: true
            };

            if (chartData.chart && !chartData.chart.height) {
                chartData.chart.height = defaultHeight;
            }

            if (chartData.displayTotal && !_.isEmpty(chartData.series)) {
                // check if legend click handler was not passed from the parent component
                if (chartData.plotOptions && !chartData.plotOptions.series.point.events.legendItemClick) {
                    chartData.plotOptions.series.point.events.legendItemClick = updateTotal;
                }

                var totalValue = _.floor(_.sumBy(chartData.series[0].data, 'y'), 2);

                totalSubTitle.text = totalSubTitle.text + totalValue;
                chartData.subtitle = totalSubTitle;
            }


            $chartEl = Highcharts.chart(element, chartData);
            if (chartData && chartData.xAxis && chartData.xAxis.type === 'datetime') {
                if (chartData.series && chartData.series.length > 1) {
                    $chartEl.container.classList.add('hc-series-' + Math.min(10, chartData.series.length));
                }
            } else if (chartData.series && chartData.series.length > 0 && chartData.series[0].data && chartData.series[0].data.length > 1) {
                $chartEl.container.classList.add('hc-series-'+ Math.min(10, chartData.series[0].data.length));
            }

            if (selected && selected.length && $chartEl.series.length && ($chartEl.series[0].data.length > selected[0])) {
                $chartEl.series[0].data[selected[0]].select();
            }

            if (chartOptions.reflowSignal) {
                chartOptions.reflowSignal.add(reflow);
            }

            function reflow(delay) {
                if (!_.isEmpty($chartEl)) {
                    // timeout needed to reflow charts after sidebar show/hide animations.
                    setTimeout(function () { $chartEl.reflow(); }, (delay || 0));
                }
            }

            function updateTotal() {
                /* jshint ignore:start */
                // ignore "possible strict violation" on using "this". This function is attached to the Highchart
                // legend and will therefore be in context of the Highcharts object.
                var newTotal = this.visible ? totalValue -= this.y : totalValue += this.y;
                $chartEl.setTitle(null, {text: 'Total: ' + _.floor(newTotal, 2)});
                /* jshint ignore:end */
            }
        }
    };
